import React from 'react';
import { Pressable, Text } from 'react-native';
import type { IChipProps } from '@shared/types';

export const Chip = ({ label, selected, onPress }: IChipProps) => (
    <Pressable
        onPress={onPress}
        accessibilityRole="button"
        accessibilityState={{ selected }}
        className={`h-[48px] items-center justify-center rounded-full border px-md ${
            selected ? 'border-primary-700 bg-primary-700' : 'border-gray-400 bg-white'
        }`}
    >
        <Text className={`text-sm font-bold ${selected ? 'text-white' : 'text-primary-700'}`}>{label}</Text>
    </Pressable>
);
